module.exports = __webpack_public_path__ + "img/2025-08-16b_7.d8c887eb.jpg";